import { kPtOverlay1 } from './pt-overlay-part1'
import { kPtOverlay2 } from './pt-overlay-part2'
import { kPtOverlay3 } from './pt-overlay-part3'
import { kPtOverlay4 } from './pt-overlay-part4'

// European-Portuguese (pt-pt) overlay for the shared backend dictionary, which ships no pt values.
// merged into DictionaryService.entries when the active locale is Portuguese, so every
// dictionary-driven page (Billettique and the rest) renders Portuguese instead of falling back to
// the English default. keys are the exact backend dictionary keys ; values are pre-resolved pt strings.
export const kBackendPtOverlay: Record<string, string> = {
  ...kPtOverlay1,
  ...kPtOverlay2,
  ...kPtOverlay3,
  ...kPtOverlay4,
}
